<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>运单管理</h4>
    </div>

    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="handleClick">
    <el-tab-pane label="运单查询" name="first">

    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="派车时间:" prop="">
                <el-date-picker
                  v-model="searchFrom1.sendCarStartTime"
                  size="mini"
                  type="datetime"
                  placeholder="选择日期">
                </el-date-picker>&nbsp;-&nbsp;&nbsp;
                <el-date-picker
                  v-model="searchFrom1.sendCarEndTime"
                  size="mini"
                  placeholder="选择日期"
                  type="datetime"
                ></el-date-picker>
             </el-form-item>
               <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom1.customerName" style="width:180px"></el-input>
              </el-form-item>
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom1.contractNo" style="width:180px"></el-input>
              </el-form-item>
              <el-form-item label="流向:" prop="flowtoType">
                <el-select v-model="searchFrom1.flowtoType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in liuXiangOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="运单号:" prop="waybillNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom1.waybillNo"></el-input>
              </el-form-item>
              <el-form-item label="车号:" prop="vehicleNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom1.vehicleNo"></el-input>
              </el-form-item>
              <el-form-item label="承运车队:" prop="fleetCode">
                <el-select v-model="searchFrom1.fleetCode" placeholder="请选择">
                 <el-option
                    v-for="(item,index) in fleetOptions"
                    :key="index"
                    :label="item.tenantName"
                    :value="item.tenantCode">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='00DP003B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='00DP003B002' v-if="btnFlg[1]" >重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="huanYuan" btnCode='00DP003B008' v-if="btnFlg[7]" >还原车辆</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableDate"
        ref="table"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        @row-click = 'handleRowClick2'
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="waybillNo" label="运单号" align="center" width="200"></el-table-column>
        <el-table-column prop="vehicleNo" label="车号" align="center" width="120" ></el-table-column>
        <el-table-column prop="name" label="装车明细" align="center"  >
          <template slot-scope="scope"><div>
              <el-button type="text" size="mini"   @click="seeClick(scope.row)" btnCode='00DP003B003' v-if="btnFlg[2]">查看</el-button>
            </div></template>
        </el-table-column>
        <el-table-column property="fleetName" label="车队"  align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="driverName"    label="司机" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="driverMobile"  label="手机号" align="center" width="120"></el-table-column>
        <el-table-column prop="flowtoTypeShow"  label="流向" align="center"></el-table-column>
        <el-table-column prop="warehouseName"  label="指派垛位" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="客户名称" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="" label="合同编号" align="center" width="180" show-overflow-tooltip :formatter="emptyFn">
          <template slot-scope="scope"><div> 
            <span v-if="scope.row.flowtoType != '1' && scope.row.weightFlg=='T'">理计合同</span>
            <span v-else>{{scope.row.contractNo}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="planNo"    label="计划编号" align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="waybillStatusShow" label="状态" align="center" width="150"></el-table-column>
        <el-table-column prop="theorySuttle"   label="理重" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="realSuttle"    label="实重" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="sendcatTimeShow"    label="派车时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="firsttareTimeShow"    label="一检时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="startloadTimeShow" label="装车开始时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="lockTimeShow" label="装车结束时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="suttleTimeShow" label="二检时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="rebillFtime" label="完成时间" align="center" width="180" :formatter="emptyFn">
          <template slot-scope="scope">
              <span>{{scope.row.rebillFtime | dateFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="到货凭证" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="seeImgClick(scope.row)" btnCode='00DP003B009' v-if="btnFlg[8]" >查看</el-button>
            </div>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom1.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--查看-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="zhuangCheMingXiMark"
    width="1000px"
    center>
      <span>
         <el-form
          :model="mingXiFrom"
          ref="mingXiFrom"
          class="demo-form-inline"
          label-width="110px" size="mini">
        <div class="addinpBox">
                <el-table
                  :data="xiangQingData"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:90%;margin-top:10px;margin-left:4%;margin-bottom:17px"
                  center
                  :summary-method="getSummaries"
                  show-summary
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="contractNo"    label="合同号" align="center" width="120"></el-table-column>
                  <el-table-column prop="deliverNo"   label="交货单号" align="center"  ></el-table-column>
                  <el-table-column property="materielCode" label="物料号"  align="center" ></el-table-column>
                  <el-table-column prop="plateId"    label="板序号" align="center" ></el-table-column>
                  <!-- <el-table-column prop=""    label="垛位" align="center" >
                    <template slot-scope="scope">
                      <span v-if="scope.row.locNo && scope.row.stockId && scope.row.locX && scope.row.locY">{{scope.row.locNo}}-{{scope.row.stockId}}-{{scope.row.locX}}{{scope.row.locY}}</span>
                      <span v-else>-</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column property="plateNum" label="数量"  align="center" ></el-table-column>
                  <el-table-column prop="theoretWeight"    label="理重（吨）" align="center" ></el-table-column>
                  <el-table-column property="actualWeight" label="过磅（吨）"  align="center" ></el-table-column>
                  <el-table-column prop="materielSpec"    label="规格" align="center" ></el-table-column>
                </el-table>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="heTongQuXiaoClick" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    <!-- 到货凭证 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="imgMark"
    width="500px"
    center>
      <span>
        <div class="" v-for="(item,ix) in srcList2" :key="ix" style="width:150px;height:150px;margin:0 auto;">
          <el-image
              fit="cover"
              :src="item"
              style="width:100%;height:100%;"
              :preview-src-list="getSrcList2()"
            />
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgMark = false" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    </el-tab-pane>
    <!--撤销审核-->
    <el-tab-pane label="撤销审核" name="second">
      <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="heTongFrom" ref="heTongFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="派车时间:" prop="">
                <el-date-picker
                  v-model="heTongFrom.sendCarStartTime"
                  size="mini"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>&nbsp;-&nbsp;&nbsp;
                <el-date-picker
                  v-model="heTongFrom.sendCarEndTime"
                  size="mini"
                  placeholder="选择日期时间"
                  type="datetime">
                </el-date-picker>
             </el-form-item>
              <el-form-item label="审核状态:" prop="auditFlag">
                <el-select v-model="heTongFrom.auditFlag" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in shenHeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单号:" prop="waybillNo">
                <el-input  placeholder="" maxlength="100" v-model="heTongFrom.waybillNo"></el-input>
              </el-form-item>
              <el-form-item label="车号:" prop="vehicleNo">
                <el-input  placeholder="" maxlength="100" v-model="heTongFrom.vehicleNo"></el-input>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item>
          <el-button type="primary"  @click="cheXiaoSearch" btnCode='00DP003B004' v-if="btnFlg[3]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="cheXiaoChongZhi" btnCode='00DP003B005' v-if="btnFlg[4]">重置</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary"  @click="shenHeTongGuo" btnCode='00DP003B006' v-if="btnFlg[5]">审核通过</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="shenHeBuTongGuo" btnCode='00DP003B007' v-if="btnFlg[6]">审核不通过</el-button>
        </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="shenHeTableList"
        ref="cheXiaoShenHeTab"
        @row-click = 'handleRowClick'
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column  prop="" width="150" label="操作" align="center">
          <template slot-scope="scope">
            <div>
             <!-- 0 待审核 1审核不通过 2审核通过  1调度已派车  2一检完成-->
              <el-button type="text" size="mini" @click="shenHeTongGuo(scope.row)" btnCode='00DP003B006' v-if="btnFlg[5] && scope.row.auditFlag == '0'">审核通过</el-button>
              <el-button type="text" size="mini" @click="shenHeBuTongGuo(scope.row)" btnCode='00DP003B007' v-if="btnFlg[6] && scope.row.auditFlag == '0'">审核不通过</el-button>
              <span type="text" size="mini" v-if="scope.row.auditFlag != '0'">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="waybillNo"    label="运单号" align="center" width="200"></el-table-column>
        <el-table-column prop="vehicleNo"   label="车号" align="center"  width="130" ></el-table-column>
        <el-table-column property="fleetName" label="车队"  align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="driverName"    label="司机" align="center" width="150"></el-table-column>
        <!-- <el-table-column prop="vehicleCarry"   label="载重（吨）" align="center"  width="120"></el-table-column> -->
        <el-table-column prop="flowtoTypeShow"  label="流向" align="center"></el-table-column>
        <el-table-column prop="unsendcarReason"    label="撤销原因" align="center" width="120" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="" label="合同编号" align="center" width="180" show-overflow-tooltip>
          <template slot-scope="scope"> 
            <span v-if="scope.row.flowtoType != '1' && scope.row.weightFlg=='T'">理计合同</span>
            <span v-else>{{scope.row.contractNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planNo"  label="计划编号" align="center" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="waybillStatusShow"    label="状态" align="center" width="150"></el-table-column>
         <el-table-column prop="sendcatTimeShow"    label="派车时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="firsttareTimeShow"    label="一检时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="auditFlagShow" label="审核状态" align="center" width="180" :formatter="emptyFn"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="heTongFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="heTongFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
      </el-pagination>
    </div>
    </el-tab-pane>
  </el-tabs>

  </div>
</template>
<script>
import {
  TenantDictionary, // 字典
  yunDanGuanLi, // 列表查询
  yunDanGuanLiXiangQing, // 运单详情
  cheXiaoShenHe, // 撤销审核数据
  shenHeAuditFlag, // 审核通过/不通过
  restoreVehicle, // 还原车辆
  jiChuGuanLiChangeFleet,  // 车队下拉框
  receiptImg   // 到货凭证
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP003B001', '00DP003B002', '00DP003B003',
        '00DP003B004', '00DP003B005', '00DP003B006', '00DP003B007','00DP003B008','00DP003B009'],
      activeName: 'first',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        pageNo: 1,
        pageSize: 10,
        sendCarStartTime: '',
        sendCarEndTime:'',
        customerName:'',
        contractNo:'',
        flowtoType:'',
        waybillNo:'',
        vehicleNo:'',
        fleetCode:''
      },
      fleetOptions:[],  // 车队
      liuXiangOptions: [],
      value: '',
      tableDate: [],
      shenHeTableList: [],
      // 查看
      zhuangCheMingXiMark: false,
      xiangQingData: [],
      heTongFrom: {
        pageNo: 1,
        pageSize: 10,
        sendCarStartTime: '',
        sendCarEndTime:'',
        auditFlag:'',
        waybillNo:'',
        vehicleNo:''
      },
      total1: 0,
      // 审核状态
      shenHeOptions: [{
        value: '0',
        label: '待审核'
      }, {
        value: '1',
        label: '审核不通过'
      }, {
        value: '2',
        label: '审核通过'
      }],
      auditFlag: '', // 判断审核状态
      yunDanId: '', // 运单id
      mingXiFrom: {

      },
      waybillStatus: '',
      waybillId: '',
      imgMark:false,
      srcList2:[]
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getFleet()
    this.getDictionary()
    this.getToDay()
    this.getSearctData(this.searchFrom1)
    // this.getCheXiaoData(this.heTongFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/waybillManagement')
  },
  methods: {
    // 获取车队下拉框数据
    getFleet(){
      // 车队下拉框
      jiChuGuanLiChangeFleet().then(res => {
        this.fleetOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    timeStamp2: function(value) { //具体到时分秒
				var date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
		},
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(dateEndStr)
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      let nowDate = (new Date()).getTime()
      // console.log(this.timeStamp2(new Date(dateStartStr).getTime()-86400000),'333')   // 早八点时间戳
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {//86400000 1天的毫秒
        // this.searchFrom1.sendCarStartTime = this.timeStamp(new Date())
        this.searchFrom1.sendCarStartTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000 - 86400000)
        this.searchFrom1.sendCarEndTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
        // console.log(this.searchFrom1.sendcatTimeShow, '2222')
        this.heTongFrom.sendCarStartTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000 - 86400000)
        this.heTongFrom.sendCarEndTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
        // console.log(this.heTongFrom.sendcatTimeShow, '333')
      } else {
        // 昨天的时间 
        // var day1 = new Date()
        // var s1 =  day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        // var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        // console.log(this.timeStamp2(s1),'00000000')
        this.searchFrom1.sendCarStartTime = this.timeStamp2(new Date(dateStartStr).getTime()-86400000)
        this.searchFrom1.sendCarEndTime = this.timeStamp2(new Date(dateStartStr).getTime())
        this.heTongFrom.sendCarStartTime = this.timeStamp2(new Date(dateStartStr).getTime()-86400000)
        this.heTongFrom.sendCarEndTime = this.timeStamp2(new Date(dateStartStr).getTime())
      }
    },
    // 获取流向字典数据
    getDictionary () {
      TenantDictionary({
        groupNo: 'flowto_type'
      }).then(res => {
        this.liuXiangOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 获取运单查询数据
    getSearctData () {
      yunDanGuanLi({
        pageNo: this.searchFrom1.pageNo,
        pageSize: this.searchFrom1.pageSize,
        sendCarStartTime: this.timeStamp2(this.searchFrom1.sendCarStartTime),
        sendCarEndTime:this.timeStamp2(this.searchFrom1.sendCarEndTime),
        customerName:this.searchFrom1.customerName,
        contractNo:this.searchFrom1.contractNo,
        flowtoType:this.searchFrom1.flowtoType,
        waybillNo:this.searchFrom1.waybillNo,
        vehicleNo:this.searchFrom1.vehicleNo,
        fleetCode:this.searchFrom1.fleetCode
      }).then(res => {
        this.tableDate = res.list
        this.total = res.total
      }).catch(err =>{
        this.$message.error(err.message)
      })
    },
    // 获取撤销审核数据
    getCheXiaoData () {
      cheXiaoShenHe({
        pageNo: this.heTongFrom.pageNo,
        pageSize: this.heTongFrom.pageSize,
        sendCarStartTime: this.timeStamp2(this.heTongFrom.sendCarStartTime),
        sendCarEndTime:this.timeStamp2(this.heTongFrom.sendCarEndTime),
        auditFlag:this.heTongFrom.auditFlag,
        waybillNo:this.heTongFrom.waybillNo,
        vehicleNo:this.heTongFrom.vehicleNo
      }).then(res => {
        this.shenHeTableList = res.list
        this.total1 = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击运单查询按钮
    searchClick () {
      this.getSearctData(this.searchFrom1)
    },
    // 点击运单重置按钮
    chongZhiClick () {
      this.searchFrom1 = {
          pageNo: 1,
          pageSize: 10,
          sendCarStartTime: '',
          sendCarEndTime:'',
          customerName:'',
          contractNo:'',
          flowtoType:'',
          waybillNo:'',
          vehicleNo:'',
          fleetCode:''
        }
      this.getSearctData(this.searchFrom1)
    },
    handleClick (tab, event) {
      // console.log(tab, event)
      if (tab.index == 0) {
        this.getToDay()
        this.getSearctData(this.searchFrom1)
        this.heTongFrom = {
          pageNo: 1,
          pageSize: 10,
          sendCarStartTime: '',
          sendCarEndTime:'',
          auditFlag:'',
          waybillNo:'',
          vehicleNo:''
        }
      } else if (tab.index == 1) {
        this.getToDay()
        this.getCheXiaoData(this.heTongFrom)
        this.searchFrom1 = {
          pageNo: 1,
          pageSize: 10,
          sendCarStartTime: '',
          sendCarEndTime:'',
          customerName:'',
          contractNo:'',
          flowtoType:'',
          waybillNo:'',
          vehicleNo:'',
          fleetCode:''
        }
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom1.pageSize = val
      this.getSearctData(this.searchFrom1)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom1.pageNo = val
      this.getSearctData(this.searchFrom1)
    },
    // 点击查看
    seeClick (row) {
      this.zhuangCheMingXiMark = true
      this.title = '装车明细'
      yunDanGuanLiXiangQing({
        waybillNo: row.waybillNo
      }).then(res => {
        this.xiangQingData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.zhuangCheMingXiMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      this.getCheXiaoData(this.heTongFrom)
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      this.getCheXiaoData(this.heTongFrom)
    },
    // 撤销审核查询
    cheXiaoSearch () {
      this.getCheXiaoData(this.heTongFrom)
    },
    // 撤销审核重置
    cheXiaoChongZhi () {
      this.heTongFrom = {
          pageNo: 1,
          pageSize: 10,
          sendCarStartTime: '',
          sendCarEndTime:'',
          auditFlag:'',
          waybillNo:'',
          vehicleNo:''
        }
      this.getCheXiaoData(this.heTongFrom)
    },
    // 点击每行数据触发事件
    handleRowClick (row) {
      // console.log(row)
      this.$refs.cheXiaoShenHeTab.toggleRowSelection(row)
      this.auditFlag = row.auditFlag
      this.yunDanId = row.id
    },
    // 运单点击每行
    handleRowClick2 (row) {
      this.$refs.table.toggleRowSelection(row)
      this.waybillId = row.id
      this.waybillStatus = row.waybillStatus
    },
    // 点击审核通过
    shenHeTongGuo (row) {
      // console.log(this.auditFlag)
      // let cheXiaoData = this.$refs.cheXiaoShenHeTab.selection
      // if (cheXiaoData.length < '1') {
      //   this.$message.error('请选择一条数据进行操作！')
      // } else if (this.auditFlag != '0') {
      //   // 0 待审核 1审核通过 2审核不通过
      //   this.$message.error('只能选择待审核的数据！')
      // } else {
        //0 待审核 1审核不通过 2审核通过
        if(row.waybillStatus == '1'){
          this.$confirm('确定审核通过?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            shenHeAuditFlag({
              id: row.id,
              auditFlag: '2'
            }).then(res => {
              this.$message.success('操作成功！')
              this.getCheXiaoData(this.heTongFrom)
            }).catch(err => {
              this.$message.error(err.message)
            })
          }).catch(() => {
            // this.$message.error('已取消注销');
          })
        }else{
          this.$message.error('只能选择调度已派车的数据！')
        }
        
      // }
    },
    // 点击审核不通过
    shenHeBuTongGuo (row) {
      // let cheXiaoData = this.$refs.cheXiaoShenHeTab.selection
      // if (cheXiaoData.length < '1') {
      //   this.$message.error('请选择一条数据进行操作！')
      // } else if (this.auditFlag != '0') {
      //   this.$message.error('只能选择待审核的数据！')
      // } else {
      if(row.waybillStatus == '1'){
        this.$confirm('确定审核不通过?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          shenHeAuditFlag({
            id: row.id,
            auditFlag: '1'
          }).then(res => {
            this.$message.success('操作成功！')
            this.getCheXiaoData(this.heTongFrom)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }).catch(() => {
          // this.$message.error('已取消注销');
        })
      }else{
        this.$message.error('只能选择调度已派车的数据！')
      }
      // }
    },
    // 还原车辆按钮
    huanYuan () {
      let huanYuan = this.$refs.table.selection
      // console.log(huanYuan)
      if (huanYuan.length < '1') {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.waybillStatus == '6') {
        this.$message.error('已收货的数据不能还原！')
      } else {
        this.$confirm('还原后当前正在拉运的任务会被自动完结（请谨慎操作），是否还原车辆？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          restoreVehicle({
            waybillId: this.waybillId
          }).then(res => {
            this.$message.success('操作成功！')
            this.getSearctData(this.searchFrom1)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }).catch(() => {
          // this.$message.error('已取消注销');
        })
      }
    },
    // 合计设置单位名称
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (column.label == '理重（吨）' ||
              column.label == '过磅（吨）') {
            sums[index] = sums[index].toFixed(2) + ' 吨'
            // console.log(sums[index], '11111111')
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = '/'
        }
      })

      return sums
    },
    // 点击凭证
    seeImgClick(row){
      this.srcList2 = []
      receiptImg(row.id).then((res) =>{
        this.imgMark = true
        this.title = '查看凭证'
        let imageUrl = res.imageUrl
        this.srcList2.push(imageUrl)
      }).catch(err =>{
        this.$message.error(err.message)
      })
    },
    // 点击图片放大
    getSrcList2 (ix) {
      return this.srcList2.slice(ix).concat(this.srcList2.slice(0, ix))
    },
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#409EFF;
  color: #fff;
}
// /deep/.inpBox .el-date-editor .el-input__inner {
//     width: 180px;
// }
/deep/.inpBox .el-input__inner {
    width: 180px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}
// /deep/.inpBox .el-date-editor .el-input__inner {
//     width: 150px;
// }
//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
// .el-date-editor.el-input, .el-date-editor.el-input__inner {
//     width:  150px;
// }
.searchBtnBox{
  margin-top: 10px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
